import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { clearAuthToken, setAuthToken, getAuthToken } from '@/services/apiClient';

export interface UserInfo {
  id: string;
  account: string;
  name: string;
  role: 'user' | 'patient' | 'doctor' | 'admin';
  avatar?: string;
}

export const useAuthStore = defineStore('auth', () => {
  const token = ref<string | null>(getAuthToken());
  const user = ref<UserInfo | null>(null);

  const isLoggedIn = computed(() => Boolean(token.value));

  function login(newToken: string, info: UserInfo) {
    token.value = newToken;
    user.value = info;
    setAuthToken(newToken);
    try {
      localStorage.setItem('auth_user', JSON.stringify(info));
    } catch {
      /* ignore */
    }
  }

  function updateUser(info: Partial<UserInfo>) {
    if (!user.value) return;
    Object.assign(user.value, info);
    try {
      localStorage.setItem('auth_user', JSON.stringify(user.value));
    } catch {
      /* ignore */
    }
  }

  function restore() {
    const raw = localStorage.getItem('auth_user');
    if (raw) {
      try {
        user.value = JSON.parse(raw) as UserInfo;
      } catch {
        user.value = null;
      }
    }
  }

  function logout() {
    token.value = null;
    user.value = null;
    clearAuthToken();
    localStorage.removeItem('auth_user');
  }

  return { token, user, isLoggedIn, login, logout, updateUser, restore };
});
